import { EnumValueObject } from "src/contexts/_shared/domain/EnumValueObject";
import { InvalidDocumentWithContentFileExtensionErrorFile } from "../errors/InvalidDocumentWithContentFileExtensionError";

enum DocumentWithContentFileExtensions {
  PDF = "pdf",
  JPG = "jpg",
  JPEG = "jpeg",
  PNG = "png",
}
export class DocumentWithContentFileExtension extends EnumValueObject<DocumentWithContentFileExtensions> {
  constructor(value: string) {
    super(value, Object.values(DocumentWithContentFileExtensions));
  }

  protected throwErrorForInvalidValue(value: DocumentWithContentFileExtensions): void {
    throw new InvalidDocumentWithContentFileExtensionErrorFile(value.toString());
  }

  static fromContentType(contentType: string): DocumentWithContentFileExtension {
    const value = contentType.split("/").pop() as string;
    return new DocumentWithContentFileExtension(value);
  }
}
